import React from "react";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { Lock } from "@gaming/xds-react-js-icons";

import { useStrings } from "../../../localization/localizationHelpers";
import * as styles from "./LockIcon.module.css";

export const LockIcon = () => {
  const [lockIcon] = useStrings("lockIcon");

  return (
    <Icon className={styles.lockIcon} title={lockIcon} icon={Lock} iconSize={IconSize.Custom} />
  );
};
